module.exports = __webpack_public_path__ + "img/adict_300.84045dfa.jpg";